import _ from "lodash";
import React, { useEffect, useState } from "react";

import { api } from "@/api";
import dayjs from "@/lib/helpers/dayjs";

import { AppointmentTimePicker } from "../../Schedule/AppointmentTimePicker";
import { getTodaysDate } from "../../Schedule/AppointmentTimePicker/helpers";

const ScheduleCall = ({
  selectedAppointment,
  setSelectedAppointment,
  sharedWorkflowData,
  timezone,
}) => {
  const patientId = _.get(sharedWorkflowData, "workflow_instance.state.patient_id");
  const [intakeAppointments, setIntakeAppointments] = useState(null);

  useEffect(() => {
    (async () => {
      const today = getTodaysDate();
      /** To avoid non-shows we want to give some offset to the user to let them properly setup to the platform before the first visit
       * Add 2 days offset to the patient created date
       */
      const startTimestamp = today.add(2, "days");

      /** Fetch from start date to end of next week (2 weeks total)
       * If today is Tuesday, only fetch Thu-Sun (offset + remaining days of this week) + 1 additional full week (Mon-Sun)
       */
      const endOfNextWeekTimestamp = dayjs(startTimestamp).endOf("isoWeek").add(1, "week");

      const data = {
        end_iso_timestamp: endOfNextWeekTimestamp.toISOString(),
        id: patientId,
        start_iso_timestamp: startTimestamp.toISOString(),
        timezone: timezone,
      };

      const availability = await api.patient.get_upcoming_intake_availability({ data });

      setIntakeAppointments(availability?.["upcoming_availability"]);
    })();
  }, []);

  const timePickerProps = {
    appointments: intakeAppointments,
    disableNextArrow: false,
    patientDetails: { username: patientId },
    selectedAppointment,
    setAppointments: setIntakeAppointments,
    setSelectedAppointment,
  };

  return (
    <div className="tw:w-full">
      {intakeAppointments && <AppointmentTimePicker {...timePickerProps} />}
      {!intakeAppointments && (
        <div className="m-3 font-italic txt-gry">Loading Therapist Availability...</div>
      )}
    </div>
  );
};

export default ScheduleCall;
